jQuery.noConflict();
(function($){
  $(function() {
  $('.--Acd').click(function() { //アコーディオン
    $(this).toggleClass('--Selected');
    $($(this).parent().attr('data-content')).slideToggle();
  });
    w = $(window).width();
    if (w <= 600) { //SP
      var pos;
      var $body = $('body');  
      $('#js__btn').on('click', function () { //開閉用ボタンをクリックでクラスの切替え
        scrollPosition = $(window).scrollTop();
        $body.toggleClass('open').css({'top': -scrollPosition});
      });
      $('#js__nav a').on('click', function () {
        $body.removeClass('open').css({'top': 0});
        window.scrollTo(0, scrollPosition);
      });
      $('a[href^="#"]').click(function() { // スムーススクロール
        var speed = 500;
        var adjust = $('.GlobalLayout__Header').height();
        var href = $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top - adjust;
        $('body,html').animate({scrollTop: position}, speed, 'swing');
        return false;
      });
    } else { //PC
      var headerHight = 90;
      $('.GlobalNavi a[href^="#"]').click(function () {
        var href = $(this).attr("href");
        var target = $(href == "#" || href == "" ? "html" : href);
        var position = target.offset().top - headerHight;
        $("html, body").animate({ scrollTop: position }, 500, "linear");
        return false;
      });
    }
  });
}(jQuery));